/**
 * @desc AJS compliant router function to handle migration routes
 * @param {angular.$stateProvider} $stateProvider - Angular stateprovider to handle states
 * @return {void}
 */
export function AgentsRouter($stateProvider) {
  $stateProvider
    .state('app.agents', {
      url: '/agents',
      template: '<app-agents></app-agents>',
    })
}



// WEBPACK FOOTER //
// ./src/app/agents/agents.router.js